import { useAtomValue, useSetAtom } from "jotai";
import { type ChangeEvent, useState } from "react";
import { widgetMenuOptionsAtom, widgetMenuOptionsByNameAtom } from "@/interface/AppStore";
import { applyValue, setNewOptions } from "../../lib";
import type { SetActiveSubMenu } from "../../types";
import { RangeInput } from "../RangeInput/RangeInput";
import styles from "./WidthInput.module.css";

interface WidthInputProps {
    setActiveSubMenu: SetActiveSubMenu;
}

export function WidthInput({ setActiveSubMenu }: WidthInputProps) {
    const options = useAtomValue(widgetMenuOptionsByNameAtom("width"));
    const setWidgetMenuOptions = useSetAtom(widgetMenuOptionsAtom);

    const uniqueValues = [...new Set(options.map((option) => option.value))];

    const [width, setWidth] = useState((uniqueValues[0] as number) ?? 1);

    const handleRangeChange = (event: ChangeEvent<HTMLInputElement>) => {
        setActiveSubMenu(null);

        const rangeValue = Number(event.currentTarget.value);

        setWidth(rangeValue);

        const setNewWidthOptions = setNewOptions({ name: "width", setWidgetMenuOptions });

        applyValue({ options, value: rangeValue, setNewOptions: setNewWidthOptions });
    };

    return (
        <RangeInput
            className={styles.range}
            min={1}
            max={15}
            step={1}
            value={width}
            name="lineWidth"
            onChange={handleRangeChange}
        />
    );
}
